import React from "react";

const TimeOfDayDocumentation = (
    <p>
        <p>
            This will allow that trades only occur between the start hour and minute and the end hour and minute.
            Please note that the time is according to "military time". So instead of 2 pm, you would do 14:00.
            Ex: If Start Hour is set to 11, start Minute is set to 30, end hour is set to 15, end minute is set to 15,
            this will filter out all entries that trigger before 11:30 am, and after 3:15 pm.
        </p>
    </p>
)
export default TimeOfDayDocumentation;